import { Link } from '@tanstack/react-router';

import type { InputProps } from '@/_components';
import { FormControl, FormItem, FormMessage, Input } from '@/_components';
import type { ToPath } from '@/types';

export const FormInputWithToLink = ({
  ref,
  formItemClassName,
  value,
  className,
  to,
  params = {},
  ...props
}: InputProps & { formItemClassName?: string; to: ToPath; params?: Record<string, string> }) => {
  const inputRender = (
    <Input
      {...props}
      containerProps={{
        className: props.disabled && Boolean(value) ? 'cursor-pointer group' : '',
      }}
      className={`${className} decoration-primary decoration-2 disabled:pointer-events-none group-hover:disabled:underline`}
      value={`${value || ''}`.toLowerCase()}
      onChange={(e) =>
        props?.onChange?.({ ...e, target: { ...e.target, value: `${e.target.value || ''}`.toLowerCase() } })
      }
      ref={ref}
    />
  );

  return (
    <FormItem className={formItemClassName}>
      <FormControl>
        {props.disabled ? (
          <Link to={to} params={params}>
            {inputRender}
          </Link>
        ) : (
          inputRender
        )}
      </FormControl>
      <FormMessage />
    </FormItem>
  );
};
